import styles from './Question.module.css';

import logo from '../../assets/images/logo.png';

function Question({ title, questionFontSize }) {
  const titleArr = title.split('\n').map((el) => el.replace('\r', ''));

  return (
    <div className={styles.questionWrapper}>
      <div className={styles.questionBlock}>
        {titleArr[0] && (
          <div
            className={styles.firstLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              '--animDelay': `${0}s`,
            }}
          >
            <div>{titleArr[0]}</div>
          </div>
        )}
        {titleArr[1] && (
          <div
            className={styles.secondLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              '--animDelay': `${1.27}s`,
            }}
          >
            <div>{titleArr[1]}</div>
          </div>
        )}
        {titleArr[2] && (
          <div
            className={styles.thirdLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              '--animDelay': `${2.54}s`,
            }}
          >
            <div>{titleArr[2]}</div>
          </div>
        )}
        {titleArr[3] && (
          <div
            className={styles.fourthLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              '--animDelay': `${3.81}s`,
            }}
          >
            <div>{titleArr[3]}</div>
          </div>
        )}
      </div>
      <img src={logo} alt="logo" className={styles.logo} />

      <div
        // initial={{ scale: 0, originY: '100%', originX: '100%' }}
        // animate={{ scale: 1, originY: '100%', originX: '100%' }}
        // transition={{ duration: 0.33, delay: 5.38 }}
        className={`${styles.questBlock} ${styles.one}`}
        style={{ '--animDelay': `${5.38}s` }}
      >
        <div className={`${styles.quest} ${styles.one}`}>?</div>
      </div>

      <div
        // initial={{ scale: 0, originY: '100%', originX: '100%' }}
        // animate={{ scale: 1.36, originY: '100%', originX: '100%' }}
        // transition={{ duration: 0.33, delay: 5.21 }}
        className={`${styles.questBlock} ${styles.two}`}
        style={{ '--animDelay': `${5.21}s` }}
      >
        <div className={`${styles.quest} ${styles.two}`}>?</div>
      </div>

      <div
        // initial={{ scale: 0, originY: '100%', originX: '100%' }}
        // animate={{ scale: 1, originY: '100%', originX: '100%' }}
        // transition={{ duration: 0.33, delay: 5.08 }}
        className={`${styles.questBlock} ${styles.three}`}
        style={{ '--animDelay': `${5.08}s` }}
      >
        <div className={`${styles.quest} ${styles.three}`}>?</div>
      </div>

      <div
        // initial={{ scale: 0, originY: '100%', originX: '0' }}
        // animate={{ scale: 1, originY: '100%', originX: '0' }}
        // transition={{ duration: 0.33, delay: 5.08 }}
        className={`${styles.questBlock} ${styles.four}`}
        style={{ '--animDelay': `${5.08}s` }}
      >
        <div className={`${styles.quest} ${styles.four}`}>?</div>
      </div>

      <div
        // initial={{ scale: 0, originY: '100%', originX: '0' }}
        // animate={{ scale: 1.36, originY: '100%', originX: '0' }}
        // transition={{ duration: 0.33, delay: 5.38 }}
        className={`${styles.questBlock} ${styles.five}`}
        style={{ '--animDelay': `${5.38}s` }}
      >
        <div className={`${styles.quest} ${styles.five}`}>?</div>
      </div>

      <div
        // initial={{ scale: 0, originY: '100%', originX: '0' }}
        // animate={{ scale: 1, originY: '100%', originX: '0' }}
        // transition={{ duration: 0.33, delay: 5.21 }}
        className={`${styles.questBlock} ${styles.six}`}
        style={{ '--animDelay': `${5.21}s` }}
      >
        <div className={`${styles.quest} ${styles.six}`}>?</div>
      </div>
    </div>
  );
}

export default Question;
